<template>
  <div>
    <b-card>
      <div slot="header">{{ $lang.teachingExperienceEdit }}</div>
      <LoadingSpinner :loading="isLoading" :text="loadingSpinnerText" />
      <TeachingExperienceForm
        v-show="!isLoading"
        :item="item"
        :parentPermissions="parentPermissions"
        @cancel="cancel"
        @submit="save"
      />
    </b-card>
  </div>
</template>
<script>
import TeachingExperienceForm from "./../forms/teachingExperienceForm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { generateApiUrl, generateError, toastAlert } from "@/shared/utils";

export default {
  data() {
    return {
      isLoading: false,
      item: null,
      loadingSpinnerText: this.$lang.receiving_data,
    };
  },
  components: {
    TeachingExperienceForm,
    LoadingSpinner,
  },
  props: {
    itemId: {
      type: [Number, String],
      default: null,
    },
    code: {
      type: [Number, String],
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    itemId: {
      immediate: true,
      handler() {
        this.fetchData();
      },
    },
  },
  methods: {
    pathOr,
    cancel() {
      this.$emit("cancel");
    },
    async save(payload) {
      try {
        this.loadingSpinnerText = this.$lang.sending_data;
        this.isLoading = true;
        const url = generateApiUrl(
          ["profile", "personTeachingExperience"],
          [this.code, this.itemId]
        );
        const response = await this.$httpService.put(url, payload);
        const message = pathOr("", ["data", "message"], response);
        toastAlert(message);
        this.cancel();
        this.$emit("getData");
      } catch (error) {
        generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        this.loadingSpinnerText = this.$lang.receiving_data;
        this.isLoading = true;
        const url = generateApiUrl(
          ["profile", "personTeachingExperience"],
          [this.code, this.itemId]
        );
        const response = await this.$httpService.get(url);
        this.item = pathOr(null, ["data", "data"], response);
      } catch (error) {
        generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
